import { ACTION_TYPE } from "../../Services/index";
export const initialState = {
	likes: [],
};

export const likesReducer = (state = initialState, action) => {
	console.log("likes", action.type);
	console.log("likes data", action.payload);

	switch (action.type) {
		case ACTION_TYPE.LIKEPOST:
			return {
				...state,
				likes: action.payload?.data,
			};

		default:
			return state;
	}
};
